import React from "react";
import { useAdminContext } from "../provider/AdminContext";

const DrilldownHeader = ({ title, breadcrumbs = [] }) => {
  const { goBack } = useAdminContext();

  return (
    <div className="mb-6">
      <button
        onClick={goBack}
        className="flex items-center text-sm text-blue-600 hover:text-blue-800 mb-2"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-4 w-4 mr-1"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 19l-7-7 7-7"
          />
        </svg>
        Back
      </button>

      {breadcrumbs.length > 0 && (
        <p className="text-sm text-gray-500 mb-1">
          {breadcrumbs.join(" / ")}
        </p>
      )}

      <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
    </div>
  );
};

export default DrilldownHeader;
